<template>
  <div class="w-100">
    <table
      class="table table-bordered stripe display compact hover"
      :id="table_name">
      <thead>
      <tr>
        <template>
          <th style="font-size: 13px !important; width: 50px"></th>
          <th style="font-size: 13px !important; width: 120px">Lugar</th>
          <th style="font-size: 13px !important; width: 65px">Fecha</th>
          <th style="font-size: 13px !important; width: 110px">Descripción</th>
          <th style="font-size: 13px !important; width: 90px">Nave</th>
          <th style="font-size: 13px !important; width: 90px">Viaje</th>
          <th style="font-size: 13px !important; width: 65px">Fecha recepción</th>
        </template>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in data" :key="index">
        <template>
          <td :style="{ backgroundColor: item.row_color ? item.row_color : '','font-weight': 'bolder' }">
            {{ index + 1 }}
          </td>
          <td
            :style="{ backgroundColor: item.row_color ? item.row_color : '', 'font-weight': item.highlight  ? 'bolder' : '' }">
            {{ item.location + " - " + item.port_name }}
          </td>
          <td
            :style="{ backgroundColor: item.row_color ? item.row_color : '', 'font-weight': item.highlight  ? 'bolder' : '' }">
            {{ item.movement_date }}
          </td>
          <td
            :style="{ backgroundColor: item.row_color ? item.row_color : '', 'font-weight': item.highlight  ? 'bolder' : '' }">
            {{ item.status_name }}
          </td>
          <td
            :style="{ backgroundColor: item.row_color ? item.row_color : '', 'font-weight': item.highlight  ? 'bolder' : ''}">
            {{ item.vessel }}
          </td>
          <td
            :style="{ backgroundColor: item.row_color ? item.row_color : '', 'font-weight': item.highlight  ? 'bolder' : ''}">
            {{ item.voyage }}
          </td>
          <td
            :style="{ backgroundColor: item.row_color ? item.row_color : '', 'font-weight': item.highlight  ? 'bolder' : '' }">
            {{ item.document_date }}
          </td>
        </template>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import { mapActions, mapState } from "vuex";

import $ from "jquery";

export default {
  props: {
    headers: Array,
    data: Array,
    acciones: Array,
    paginacion: Boolean,
    max: { type: Number, default: 5 },
    buscar: Boolean,
    table_id: {
      type: String,
      default: "id_generico"
    }
  },

  data() {
    return {
      loading: true,
      lang: {
        lengthMenu: "Display _MENU_ records per page",
        zeroRecords: "No se encontraron registros coincidentes",
        info: "Mostrando página _PAGE_ de _PAGES_",
        infoEmpty: "No hay registros disponibles",
        infoFiltered: "(filtrado de _MAX_ registros totales)",
        search: "Buscar",
        paginate: {
          first: "Primero",
          last: "Último",
          next: "Siguiente",
          previous: "Anterior"
        }
      },
      table_name: "id_tabla_" + this.table_id
    };
  },

  computed: {

    ...mapState(["zIndexModal", "ZindexTablaModal"])

  },

  methods: {

    ...mapActions(["ActionSetLoading"]),

    configuracionDatatable() {

      $("#" + this.table_name).DataTable().destroy();

      $("#" + this.table_name).DataTable({
        paging: this.paginacion,
        pageLength: this.max,
        searching: this.buscar,
        lengthChange: false,
        ordering: true,
        info: true,
        autoWidth: false,
        responsive: true,
        checkd: false,
        language: this.lang
      }).buttons().container().appendTo("#" + this.table_name + "_wrapper .col-md-6:eq(0)");

    }

  },

  mounted() {

    this.configuracionDatatable();

  },

  watch: {

    data: function(_new) {

      if (_new) {

        $("#" + this.table_name).DataTable().destroy();

        setTimeout(() => {

          this.data = _new;

        }, 300);

        setTimeout(() => {

          this.configuracionDatatable();

          this.ActionSetLoading(false);

        }, 700);

      }

    }

  }

};
</script>

<style>
.hide-button-excel {
  display: none;
}

.buttons-colvis {
  background-color: #dc3545;
  color: #ffff;
  padding: 6px;
  border: none;
  border-radius: 3px;
  font-size: 15px;
}

.buttons-colvis:hover {
  background-color: #bd2130;
  border: none;
}

div.dataTables_wrapper div.dataTables_info {
  font-size: 13px !important;
}

.icono {
  opacity: 0.7;
}

.icono:hover {
  opacity: 1;
}

.btn-group-sm > .btn,
.btn-sm {
  padding: 0.25rem 0.45rem !important;
}

/* Table compact */

table.dataTable.compact thead th,
table.dataTable.compact thead td {
  padding: 3px 5px;
}

table.dataTable.compact tfoot th,
table.dataTable.compact tfoot td {
  padding: 3px;
}

table.dataTable.compact tbody th,
table.dataTable.compact tbody td {
  padding: 3px;
}

/* Table Hover */

table.dataTable.hover > tbody > tr:hover > * {
  box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.087) !important;
}

/* Stripe (Pintado de tabla estilo cebra) */

table.dataTable.stripe > tbody > tr.odd > *,
table.dataTable.display > tbody > tr.odd > * {
  box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.048);
}

/*  */

table.dataTable thead > tr > th.sorting,
table.dataTable thead > tr > th.sorting_asc,
table.dataTable thead > tr > th.sorting_desc,
table.dataTable thead > tr > th.sorting_asc_disabled,
table.dataTable thead > tr > th.sorting_desc_disabled,
table.dataTable thead > tr > td.sorting,
table.dataTable thead > tr > td.sorting_asc,
table.dataTable thead > tr > td.sorting_desc,
table.dataTable thead > tr > td.sorting_asc_disabled,
table.dataTable thead > tr > td.sorting_desc_disabled {
  cursor: pointer;
  position: relative;
  padding: 10px 0 !important;
  text-align: center;
}

.estilo_select {
  width: 100% !important;
  border-radius: 0.25em;
  padding: 5px 1px;
  font-size: 14px;
}
</style>
